import type { NavState } from './types'

export function formatDate(dateString: string): string {
  return new Date(dateString + 'T00:00:00').toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}

export function getStatusDot(status: string): string {
  switch (status) {
    case 'active': return 'bg-green-500'
    case 'upcoming': return 'bg-blue-500'
    case 'completed': return 'bg-gray-400'
    default: return 'bg-gray-400'
  }
}

export function getStatusLabel(status: string): string {
  switch (status) {
    case 'active': return 'Active'
    case 'upcoming': return 'Upcoming'
    case 'completed': return 'Completed'
    default: return status
  }
}

export function getInitials(name: string): string {
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
}

// Parse hash to NavState
export function parseHashToNav(hash: string): NavState {
  if (!hash || hash === '#') return { view: 'main' }
  
  const cleanHash = hash.startsWith('#') ? hash.slice(1) : hash
  const parts = cleanHash.split('/')
  
  if (parts[0] === 'season' && parts[1]) {
    return { view: 'season', seasonId: parts[1] }
  }
  if (parts[0] === 'bracket' && parts[1] && parts[2]) {
    return { view: 'bracket', seasonId: parts[1], bracketId: parts[2] }
  }
  
  return { view: 'main' }
}

// Convert NavState to hash
export function navToHash(nav: NavState): string {
  switch (nav.view) {
    case 'season':
      return `#season/${nav.seasonId}`
    case 'bracket':
      return `#bracket/${nav.seasonId}/${nav.bracketId}`
    default:
      return ''
  }
}
